import { UUID } from 'crypto'
import Licenses from '../license/Licenses'
import PaymentTransactions from '../payment/PaymentTransactions'
import { StudentDto } from '../../pages/users/api/dto/get/StudentDto'
import { StudentUI } from '../../pages/users/model/StudentUI'
import { UserInfo } from './UserInfo'

class Student {
  private constructor(
    id: UUID,
    userId: UUID,
    licenses: Licenses,
    paymentTransactions: PaymentTransactions,
  ) {
    this.id = id
    this.userId = userId
    this.licenses = licenses
    this.paymentTransactions = paymentTransactions
  }

  private readonly id: UUID
  private readonly userId: UUID
  private readonly licenses: Licenses
  private readonly paymentTransactions: PaymentTransactions

  getId(): UUID {
    return this.id
  }

  hasId(id: UUID): boolean {
    return this.id === id
  }

  toStudentUI(userInfo: UserInfo): StudentUI {
    return {
      id: this.id,
      userId: this.userId,
      licenses: this.licenses.toLicensesUI(),
      paymentTransactions: this.paymentTransactions.toPaymentTransactionsUI(),
      email: userInfo.email,
      firstName: userInfo.firstName,
      lastName: userInfo.lastName,
      fatherName: userInfo.fatherName,
      address: userInfo.address,
      phoneNumber: userInfo.phoneNumber,
      mobileNumber: userInfo.mobileNumber,
      birthday: userInfo.birthday,
      idNumber: userInfo.idNumber,
      ssrNumber: userInfo.ssrNumber,
      vatNumber: userInfo.vatNumber,
      visuallyImpaired: userInfo.visuallyImpaired,
    } satisfies StudentUI
  }

  getLicenses(): Licenses {
    return this.licenses
  }

  getTransactions(): PaymentTransactions {
    return this.paymentTransactions
  }

  static fromDto(userId: UUID, studentDto: StudentDto): Student {
    const { id, licenses, transactions } = studentDto

    return new Student(
      id,
      userId,
      Licenses.fromDto(id, licenses, studentDto.vehicleLicenses),
      PaymentTransactions.fromDto(transactions),
    )
  }
}

export default Student
